import React from 'react';
import LegacyModal, { ModalProps } from './Modal.legacy';
import AlphaModal from './Modal.alpha';

const Component = process.env.IS_LEGACY ? LegacyModal : AlphaModal;
export default Component as React.FC<ModalProps>;
export type { ModalProps };
